export default __webpack_public_path__ + "static/media/system_thermal.82ed876a.jpg";